<template>
  <component
    :class="['flippable-card', { flipping: isFlipped, 'pure-button': !!callback }]"
    :name="`${card?.cardText} card`"
    :is="callback ? 'button' : 'div'"
    @click="onCardClick"
    v-bind="$attrs"
    :tabindex="isTyping ? -1 : 0"
    :style="{ height: height ?? '100%' }"
  >
    <div class="card-front">
      <slot name="card-front"></slot>
    </div>
    <div class="card-back">
      <slot name="card-back"></slot>
    </div>
  </component>
</template>

<script>
export default {
  props: {
    isFlipped: Boolean,
    callback: Function,
    card: Object,
    isTyping: Boolean,
    height: String
  },

  methods: {
    onCardClick(event) {
      if (this.callback) {
        this.callback(this.card, event);
      }
    }
  }
};
</script>

<style lang="scss">
.flippable-card,
.flippable-card .card-back,
.flippable-card .card-front {
  overflow: hidden;
}

.flippable-card {
  display: block;
  left: 0;
  padding: 0px;
  perspective: 600px;
  position: relative;
  top: 0;
}

.flippable-card .card-back {
  z-index: 9;
  position: relative;
  transform: rotateX(0deg) rotateY(0deg);
  transform-style: preserve-3d;
  backface-visibility: hidden;
  transition: all 0.5s ease-in-out;
}

.flippable-card.flipping .card-back {
  z-index: 9;
  transform: rotateY(-180deg);
}

.flippable-card .card-front {
  top: 0;
  left: 0;
  z-index: 8;
  position: absolute;
  overflow: hidden;
  text-align: center;

  transform: rotateY(180deg);
  transform-style: preserve-3d;
  backface-visibility: hidden;
  transition: all 0.5s ease-in-out;
}

.flippable-card.flipping .card-front {
  z-index: 10;
  transform: rotateX(0deg) rotateY(0deg);
}
</style>
